import React, { useState, useEffect, useMemo, useContext } from "react";
import { Spinner, Dropdown, Modal, Button, Form, Badge, ListGroup, Row, Col } from "react-bootstrap";
import Select from "react-select";
import LogoutPage from "./Logout";
import Swal from "../../../components/SystemAlert";
import { changePassword, getAdminCredentials, getAdminById, getNotasEnfermeria,
  getPasskeyRegistrationOptions,
  insertNotaEnfermeria, 
  updateEstadoNotaEnfermeria,
  verifyPasskeyRegistration} from "../../../api/AdminApi";
import { getAllPaciente } from "../../../api/pacienteApi";
import { getAllUsuario } from "../../../api/usuarioApi";
// === Excel ===
import * as XLSX from "xlsx";
import AuthContext from "../../../context/auth-context";
import { isPasskeySupported, prepareCreationOptions, serializeCredential } from "../../../utils/passkeys";
import { formatDateTimeDisplay } from "../../../utils/dateFormat";
import { getFeriadoStatus } from "../../../api/CalendarioFeriado";
import { canAccess } from "../../../utils/permissions";
import { Link } from "react-router-dom";

const ESTADOS = ["TODOS", "PENDIENTE", "FINALIZADO"];

const getProfesionalId = (cuenta) =>
  cuenta?.IdUsuario ?? cuenta?.idusuario ?? cuenta?.idUsuario ?? cuenta?.idadmin ?? cuenta?.id;

const getProfesionalNombre = (cuenta) =>
  cuenta?.nombrecompleto ??
  cuenta?.NombreCompleto ??
  cuenta?.nombreCompleto ??
  cuenta?.usuario ??
  cuenta?.Usuario ??
  cuenta?.cuenta ??
  cuenta?.username ??
  cuenta?.nombre ??
  "";

const getPacienteId = (paciente) =>
  paciente?.IdPacientes ??
  paciente?.idpacientes ??
  paciente?.idpaciente ??
  paciente?.idPaciente ??
  paciente?.IdPaciente ??
  paciente?.id;

const getPacienteNombre = (paciente) =>
  paciente?.NombrePaciente ??
  paciente?.nombrePaciente ??
  paciente?.nombrecompleto ??
  paciente?.nombreCompleto ??
  paciente?.nombre ??
  paciente?.paciente ??
  "";

const Header = () => {
  const authCtx = useContext(AuthContext);
  const [userdata, setUserData] = useState("");
  const [Preview, setPreview] = useState(localStorage.getItem("imgurl"));
  const [headerFix, setheaderFix] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passkeyBusy, setPasskeyBusy] = useState(false);
  const [loading, setLoading] = useState(true);
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  // --- Notas ---
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [showAddNoteModal, setShowAddNoteModal] = useState(false);
  const [allNotes, setAllNotes] = useState([]); // datos crudos
  const [loadingNotes, setLoadingNotes] = useState(false);
  const [savingNote, setSavingNote] = useState(false);
  const [updatingNoteId, setUpdatingNoteId] = useState(null);
  const [newNote, setNewNote] = useState("");
  const [noteCuenta, setNoteCuenta] = useState("");
  const [notePaciente, setNotePaciente] = useState("");
  const [cuentasOptions, setCuentasOptions] = useState([]);
  const [pacientesOptions, setPacientesOptions] = useState([]);
  const [loadingNoteLinks, setLoadingNoteLinks] = useState(false);
  const [tokenTimeLeft, setTokenTimeLeft] = useState("");
  const [holidayNotification, setHolidayNotification] = useState(null);

  // Filtros
  const [estadoFiltro, setEstadoFiltro] = useState("TODOS");
  const [fechaDesde, setFechaDesde] = useState(""); // yyyy-mm-dd
  const [fechaHasta, setFechaHasta] = useState(""); // yyyy-mm-dd
  const [profesionalFiltro, setProfesionalFiltro] = useState(null);
  const [pacienteFiltro, setPacienteFiltro] = useState(null);

  useEffect(() => {
    const handleScroll = () => setheaderFix(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    fetchUserData();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const updateTokenCountdown = () => {
      const expiration = localStorage.getItem("expiration") || sessionStorage.getItem("expiration");
      if (!expiration) {
        setTokenTimeLeft("");
        return;
      }

      const diff = new Date(expiration).getTime() - Date.now();
      if (Number.isNaN(diff) || diff <= 0) {
        setTokenTimeLeft("Vencido");
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      setTokenTimeLeft(
        hours > 0
          ? `${hours}h ${String(minutes).padStart(2, "0")}m`
          : `${minutes}m ${String(seconds).padStart(2, "0")}s`
      );
    };

    updateTokenCountdown();
    const interval = setInterval(updateTokenCountdown, 1000);
    return () => clearInterval(interval);
  }, []);

  const fetchUserData = async () => {
    setLoading(true);
    try {
      const resultUser = await getAdminCredentials();
      const datauser = await getAdminById(resultUser.IdUsuario);
      setUserData(datauser[0].nombrecompleto);
      try {
        const holidayStatus = await getFeriadoStatus();
        if (holidayStatus?.cleanupCompleted) {
          const noticeKey = `notification-feriados-${holidayStatus.year}-${resultUser.IdUsuario}`;
          const canManageHolidays = canAccess(datauser?.[0], "opciones");
          const needsUpload = holidayStatus.needsUpload;
          setHolidayNotification({
            id: `feriados-${holidayStatus.year}`,
            storageKey: noticeKey,
            read: localStorage.getItem(noticeKey) === "shown",
            needsUpload,
            canManageHolidays,
            title: `Calendario de feriados ${holidayStatus.year}`,
            message: needsUpload
              ? canManageHolidays
                ? `El calendario anterior se eliminó automáticamente el 2 de enero. Cargue los feriados de ${holidayStatus.year}.`
                : `El calendario anterior se eliminó automáticamente el 2 de enero. Avise a un administrador para cargar los feriados de ${holidayStatus.year}.`
              : `La limpieza anual se completó. Hay ${holidayStatus.currentYearCount} feriados cargados para ${holidayStatus.year}.`,
            dateLabel: `2 de enero de ${holidayStatus.year}`,
          });
        }
      } catch (holidayError) {
        console.error("No se pudo verificar el calendario de feriados:", holidayError);
      }
      const res = await fetch(`https://eethsa.xyz/eethsa1/${datauser[0].foto}`);
      const blob = await res.blob();
      setPreview(URL.createObjectURL(blob));
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleNotificationToggle = (isOpen) => {
    if (!isOpen || !holidayNotification || holidayNotification.read) return;
    localStorage.setItem(holidayNotification.storageKey, "shown");
    setHolidayNotification((current) => current ? { ...current, read: true } : current);
  };

  // --- Password modal handlers ---
  const handleShowPasswordModal = () => setShowPasswordModal(true);
  const handleClosePasswordModal = () => {
    setShowPasswordModal(false);
    setPasswordData({ currentPassword: "", newPassword: "", confirmPassword: "" });
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prev) => ({ ...prev, [name]: value }));
  };
  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    const { currentPassword, newPassword, confirmPassword } = passwordData;
    if (!currentPassword || !newPassword || !confirmPassword) {
      Swal.fire({ icon: "error", title: "Error", text: "Por favor, completa todos los campos." });
      return;
    }
    if (newPassword !== confirmPassword) {
      Swal.fire({ icon: "error", title: "Error", text: "La nueva contraseña y la confirmación no coinciden." });
      return;
    }
    if (newPassword.length < 6) {
      Swal.fire({ icon: "error", title: "Error", text: "La nueva contraseña debe tener al menos 6 caracteres." });
      return;
    }
    try {
      Swal.fire({ title: "Actualizando contraseña", allowOutsideClick: false, showConfirmButton: false });
      const response = await changePassword({ currentPassword, newPassword });
      if (response) {
        Swal.close();
        await Swal.fire({ icon: "success", title: "Contraseña actualizada", text: "Por seguridad, se cerraron sus sesiones. Ingrese nuevamente." });
        handleClosePasswordModal();
        authCtx.logout();
      } else {
        throw new Error(response?.message || "Error al cambiar la contraseña");
      }
    } catch (err) {
      Swal.close();
      Swal.fire({ icon: "error", title: "Error", text: err.message || "No se pudo actualizar la contraseña." });
    }
  };

  const handleRegisterPasskey = async () => {
    if (!isPasskeySupported()) {
      Swal.fire({
        icon: "info",
        title: "No disponible",
        text: "Este navegador o conexión no admite llaves de acceso.",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    setPasskeyBusy(true);
    try {
      const options = await getPasskeyRegistrationOptions();
      const credential = await navigator.credentials.create({
        publicKey: prepareCreationOptions(options.publicKey),
      });
      if (!credential) throw new Error("No se creó la llave de acceso");
      await verifyPasskeyRegistration({
        challenge: options.challenge,
        credential: serializeCredential(credential),
        deviceName: navigator.platform || "Este dispositivo",
      });
      await Swal.fire({
        icon: "success",
        title: "Llave de acceso guardada",
        text: "Ya puede usar este dispositivo para ingresar con una llave de acceso.",
        confirmButtonText: "Aceptar",
      });
    } catch (error) {
      if (error?.name !== "NotAllowedError") {
        Swal.fire({
          icon: "error",
          title: "No se pudo guardar",
          text: error.message || "No se pudo registrar la llave de acceso.",
          confirmButtonText: "Aceptar",
        });
      }
    } finally {
      setPasskeyBusy(false);
    }
  };

  // --- Notas: handlers ---
  const openNotesModal = async () => {
    setShowNotesModal(true);
    await loadNoteLinkOptions();
    await reloadNotes();
  };

  const reloadNotes = async () => {
    try {
      setLoadingNotes(true);
      const listado = await getNotasEnfermeria();
      // Normalizamos los campos de backend a un formato común
      const normalizados = (Array.isArray(listado) ? listado : []).map((n) => ({
        id: n.idnotasenfermeria ?? n.idnota ?? n.id,
        descripcion: n.descripcion ?? n.detalle ?? n.contenido ?? "",
        fechacreacion: n.fechacreacion ?? n.fechaCreacion ?? n.fechacreado ?? null,
        usuariocreacion: n.usuariocreacion ?? n.user ?? n.usuario ?? "",
        cuenta: n.cuenta ?? n.nombrecuenta ?? n.nombreCuenta ?? n.usuarioCuenta ?? "",
        paciente: n.paciente ?? n.nombrepaciente ?? n.nombrePaciente ?? "",
        idusuario: n.idusuario ?? n.IdUsuario ?? n.idcuenta ?? "",
        idpaciente: n.idpaciente ?? n.IdPaciente ?? "",
        estado: (n.estado || "").toString().toUpperCase(),
        usuarioedicion: n.usuarioedicion ?? "",
        fechaedicion: n.fechaedicion ?? null,
      }));
      setAllNotes(normalizados);
    } catch (err) {
      console.error(err);
      Swal.fire({ icon: "error", title: "Error", text: err.message || "No se pudieron cargar las notas." });
    } finally {
      setLoadingNotes(false);
    }
  };

  const closeNotesModal = () => setShowNotesModal(false);

  const profesionalOptions = useMemo(
    () =>
      cuentasOptions
        .map((cuenta) => {
          const value = getProfesionalId(cuenta);
          const label = getProfesionalNombre(cuenta) || `Profesional ${value}`;
          return value ? { value: String(value), label } : null;
        })
        .filter(Boolean),
    [cuentasOptions]
  );

  const pacienteOptions = useMemo(
    () =>
      pacientesOptions
        .map((paciente) => {
          const value = getPacienteId(paciente);
          const label = getPacienteNombre(paciente) || `Paciente ${value}`;
          return value ? { value: String(value), label } : null;
        })
        .filter(Boolean),
    [pacientesOptions]
  );

  const loadNoteLinkOptions = async () => {
    try {
      setLoadingNoteLinks(true);
      const [cuentasResult, pacientesResult] = await Promise.allSettled([
        getAllUsuario(),
        getAllPaciente(),
      ]);

      const usuarios = cuentasResult.status === "fulfilled" && Array.isArray(cuentasResult.value)
        ? cuentasResult.value
        : [];
      const profesionales = usuarios.filter((usuario) => {
        const tipo =
          usuario.tipo ??
          usuario.Tipo ??
          usuario.tipousuario ??
          usuario.TipoUsuario ??
          usuario.nombreTipoUsuario ??
          usuario.rol ??
          usuario.Rol ??
          "";
        const texto = `${tipo} ${usuario.profesional ?? ""} ${usuario.registroprofesional ?? ""}`.toLowerCase();
        return texto.includes("profesional") || Boolean(usuario.registroprofesional);
      });

      setCuentasOptions(
        profesionales.length > 0 ? profesionales : usuarios
      );
      setPacientesOptions(
        pacientesResult.status === "fulfilled" && Array.isArray(pacientesResult.value)
          ? pacientesResult.value
          : []
      );
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingNoteLinks(false);
    }
  };

  const openAddNoteModal = async () => {
    setNewNote("");
    setNoteCuenta("");
    setNotePaciente("");
    setShowAddNoteModal(true);
    await loadNoteLinkOptions();
  };
  const closeAddNoteModal = () => {
    setShowAddNoteModal(false);
    setNewNote("");
    setNoteCuenta("");
    setNotePaciente("");
  };

  const handleSaveNote = async (e) => {
    e.preventDefault();
    if (!newNote.trim()) {
      Swal.fire({ icon: "error", title: "Atención", text: "La descripción es obligatoria." });
      return;
    }
    try {
      setSavingNote(true);
      const ok = await insertNotaEnfermeria({
        descripcion: newNote.trim(),
        idusuario: noteCuenta || null,
        idcuenta: noteCuenta || null,
        idpaciente: notePaciente || null,
      });
      if (ok) {
        Swal.fire({ icon: "success", title: "Guardado", text: "Nota agregada correctamente." });
        closeAddNoteModal();
        if (showNotesModal) await reloadNotes();
      } else {
        throw new Error("No se pudo agregar la nota.");
      }
    } catch (err) {
      console.error(err);
      Swal.fire({ icon: "error", title: "Error", text: err.message || "No se pudo agregar la nota." });
    } finally {
      setSavingNote(false);
    }
  };

  const handleResolveNote = async (note) => {
    const noteId = note?.id;
    if (!noteId) {
      Swal.fire({ icon: "error", title: "Error", text: "No se encontró el ID de la nota." });
      return;
    }
    try {
      setUpdatingNoteId(noteId);
      const ok = await updateEstadoNotaEnfermeria(noteId);
      if (ok) {
        Swal.fire({ icon: "success", title: "Actualizado", text: "Nota marcada como FINALIZADO." });
        await reloadNotes();
      } else {
        throw new Error("No se pudo actualizar el estado.");
      }
    } catch (err) {
      console.error(err);
      Swal.fire({ icon: "error", title: "Error", text: err.message || "No se pudo actualizar la nota." });
    } finally {
      setUpdatingNoteId(null);
    }
  };

  // --- Helpers de fecha ---
  const toDate = (d) => {
    // Soporta "YYYY-MM-DD HH:mm:ss" o ISO. Si falla, retorna null
    if (!d) return null;
    const parsed = new Date(d);
    if (!isNaN(parsed)) return parsed;
    // Intentar manual si viene "YYYY-MM-DD HH:mm:ss"
    const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/.exec(d);
    if (match) {
      const [_, y, m, day, hh, mm, ss] = match;
      return new Date(Number(y), Number(m) - 1, Number(day), Number(hh), Number(mm), Number(ss || 0));
    }
    return null;
  };

  const formatDate = (d) => {
    const dt = toDate(d);
    return dt ? formatDateTimeDisplay(dt, "", false) : "";
  };

  // --- Aplicación de filtros + top 30 ---
  const filteredTop30 = useMemo(() => {
    let base = [...allNotes];

    // Filtro por rango de fechas (inclusive)
    if (fechaDesde) {
      const d = new Date(fechaDesde + "T00:00:00");
      base = base.filter((n) => {
        const f = toDate(n.fechacreacion);
        return f ? f >= d : false;
      });
    }
    if (fechaHasta) {
      const d = new Date(fechaHasta + "T23:59:59");
      base = base.filter((n) => {
        const f = toDate(n.fechacreacion);
        return f ? f <= d : false;
      });
    }

    // Filtro por estado
    if (estadoFiltro !== "TODOS") {
      base = base.filter((n) => (n.estado || "").toUpperCase() === estadoFiltro);
    }

    if (profesionalFiltro?.value) {
      base = base.filter((n) => String(n.idusuario || "") === String(profesionalFiltro.value));
    }

    if (pacienteFiltro?.value) {
      base = base.filter((n) => String(n.idpaciente || "") === String(pacienteFiltro.value));
    }

    // Orden por fecha desc
    base.sort((a, b) => {
      const fa = toDate(a.fechacreacion)?.getTime() ?? 0;
      const fb = toDate(b.fechacreacion)?.getTime() ?? 0;
      return fb - fa;
    });

    // Solo los últimos 30
    return base.slice(0, 30);
  }, [allNotes, estadoFiltro, fechaDesde, fechaHasta, profesionalFiltro, pacienteFiltro]);

  const totalPend = useMemo(() => allNotes.filter((n) => (n.estado || "").toUpperCase() === "PENDIENTE").length, [allNotes]);
  const totalFin = useMemo(() => allNotes.filter((n) => (n.estado || "").toUpperCase() === "FINALIZADO").length, [allNotes]);

  const limpiarFiltros = () => {
    setEstadoFiltro("TODOS");
    setFechaDesde("");
    setFechaHasta("");
    setProfesionalFiltro(null);
    setPacienteFiltro(null);
  };

  // === Excel ===
  const exportFilteredToExcel = () => {
    if (!filteredTop30 || filteredTop30.length === 0) {
      Swal.fire({ icon: "info", title: "Sin datos", text: "No hay notas para exportar con los filtros actuales." });
      return;
    }

    // Mapeamos a columnas legibles
    const rows = filteredTop30.map((n) => ({
      ID: n.id ?? "",
      Descripción: (n.descripcion ?? "").replace(/\s+/g, " ").trim(),
      Profesional: n.cuenta ?? n.idusuario ?? "",
      Paciente: n.paciente ?? n.idpaciente ?? "",
      Estado: n.estado ?? "",
      "Usuario creación": n.usuariocreacion ?? "",
      "Fecha creación": n.fechacreacion ? formatDate(n.fechacreacion) : "",
      "Usuario edición": n.usuarioedicion ?? "",
      "Fecha edición": n.fechaedicion ? formatDate(n.fechaedicion) : "",
    }));

    const ws = XLSX.utils.json_to_sheet(rows, { cellDates: false });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Notas");

    // Auto-ajuste simple de ancho por columna
    const colWidths = Object.keys(rows[0]).map((key) => ({
      wch: Math.max(
        key.length,
        ...rows.map((r) => (r[key] ? r[key].toString().length : 0))
      ) + 2,
    }));
    ws["!cols"] = colWidths;

    const hoy = new Date();
    const pad = (x) => (x < 10 ? `0${x}` : x);
    const stamp = `${hoy.getFullYear()}-${pad(hoy.getMonth() + 1)}-${pad(hoy.getDate())}_${pad(hoy.getHours())}${pad(hoy.getMinutes())}`;
    const filename = `notas_filtradas_${stamp}.xlsx`;

    XLSX.writeFile(wb, filename);
  };

  return (
    <div className={`header ${headerFix ? "sticky" : ""}`}>
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left"></div>

            <ul className="navbar-nav header-right">
              {tokenTimeLeft && (
                <li className="nav-item header-token-item d-flex align-items-center me-3">
                  <Badge
                    bg={tokenTimeLeft === "Vencido" ? "danger" : "secondary"}
                    aria-label={`Tiempo restante de sesión: ${tokenTimeLeft}`}
                  >
                    <span className="header-token-label">Token: </span>
                    {tokenTimeLeft}
                  </Badge>
                </li>
              )}
              <li className="nav-item header-notification-item">
                <Dropdown align="end" onToggle={handleNotificationToggle}>
                  <Dropdown.Toggle
                    variant="outline-primary"
                    className="header-notification-toggle"
                    aria-label={holidayNotification && !holidayNotification.read
                      ? "Notificaciones: 1 sin leer"
                      : "Abrir notificaciones"}
                    title="Notificaciones"
                  >
                    <i className="far fa-bell" aria-hidden="true"></i>
                    {holidayNotification && !holidayNotification.read && (
                      <span className="header-notification-count" aria-hidden="true">1</span>
                    )}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="header-notification-menu">
                    <div className="header-notification-heading">
                      <div>
                        <h6>Notificaciones</h6>
                        <span>{holidayNotification ? "Avisos del sistema" : "Sin avisos pendientes"}</span>
                      </div>
                      {holidayNotification && !holidayNotification.read && (
                        <Badge bg="primary">1 nueva</Badge>
                      )}
                    </div>
                    {holidayNotification ? (
                      <div className={`header-notification-entry ${holidayNotification.read ? "is-read" : "is-unread"}`}>
                        <span className={`header-notification-icon ${holidayNotification.needsUpload ? "is-warning" : "is-info"}`}>
                          <i className={holidayNotification.needsUpload ? "fas fa-exclamation" : "fas fa-info"} aria-hidden="true"></i>
                        </span>
                        <div className="header-notification-copy">
                          <strong>{holidayNotification.title}</strong>
                          <p>{holidayNotification.message}</p>
                          <span>{holidayNotification.dateLabel}</span>
                          {holidayNotification.needsUpload && holidayNotification.canManageHolidays && (
                            <Link to="/opciones" className="header-notification-action">
                              Cargar feriados
                            </Link>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="header-notification-empty">
                        <i className="far fa-bell" aria-hidden="true"></i>
                        <p>No hay notificaciones.</p>
                      </div>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </li>
              {/* Botón Notas */}
              <li className="nav-item header-notes-item d-flex align-items-center me-2">
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={openNotesModal}
                  aria-label="Abrir notas de enfermería"
                  title="Notas de enfermería"
                >
                  <i className="fas fa-sticky-note me-2" aria-hidden="true"></i>
                  <span className="header-notes-label">Notas</span>
                </Button>
              </li>

              {/* Botón Agregar */}
              <li className="nav-item header-add-note-item d-flex align-items-center me-3">
                <Button
                  variant="success"
                  size="sm"
                  onClick={openAddNoteModal}
                  title="Agregar nota"
                  aria-label="Agregar nota de enfermería"
                >
                  <i className="fas fa-plus" aria-hidden="true"></i>
                </Button>
              </li>

              {/* Perfil */}
              <li className="nav-item header-profile-item">
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  <Dropdown className="dropdown header-profile2">
                    <Dropdown.Toggle variant="" as="a" className="nav-link i-false c-pointer">
                      <div className="header-info2 d-flex align-items-center">
                        <div className="d-flex align-items-center sidebar-info">
                          <div>
                            <h4 className="mb-0">{userdata}</h4>
                          </div>
                        </div>
                        <img src={Preview} alt="" />
                      </div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="right" className="mt-3 dropdown-menu dropdown-menu-end">
                      <Dropdown.Item as="button" onClick={handleShowPasswordModal} className="d-flex align-items-center">
                        <i className="fas fa-key me-2"></i>
                        Cambiar Contraseña
                      </Dropdown.Item>

                      <Dropdown.Item
                        as="button"
                        onClick={handleRegisterPasskey}
                        disabled={passkeyBusy}
                        className="d-flex align-items-center"
                      >
                        <i className="fas fa-fingerprint me-2"></i>
                        {passkeyBusy ? "Guardando llave…" : "Guardar llave de acceso"}
                      </Dropdown.Item>

                      <Dropdown.Item as="button" className="d-flex align-items-center">
                        <LogoutPage />
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </li>
            </ul>
          </div>
        </nav>
      </div>

      {/* MODAL: Listado de Notas */}
      <Modal show={showNotesModal} onHide={closeNotesModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Notas de Enfermería</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Filtros */}
          <Form className="mb-3">
            <Row className="g-2">
              <Col xs={12} md={3}>
                <Form.Label className="mb-1">Estado</Form.Label>
                <Form.Control as="select" value={estadoFiltro} onChange={(e) => setEstadoFiltro(e.target.value)}>
                  {ESTADOS.map((e) => (
                    <option key={e} value={e}>{e}</option>
                  ))}
                </Form.Control>
              </Col>
              <Col xs={12} md={3}>
                <Form.Label className="mb-1">Desde</Form.Label>
                <Form.Control
                  type="date"
                  value={fechaDesde}
                  onChange={(e) => setFechaDesde(e.target.value)}
                />
              </Col>
              <Col xs={12} md={3}>
                <Form.Label className="mb-1">Hasta</Form.Label>
                <Form.Control
                  type="date"
                  value={fechaHasta}
                  onChange={(e) => setFechaHasta(e.target.value)}
                />
              </Col>
              <Col xs={12} md={3}>
                <Form.Label className="mb-1">Profesional</Form.Label>
                <Select
                  className="eethsa-select"
                  classNamePrefix="eethsa-select"
                  value={profesionalFiltro}
                  onChange={setProfesionalFiltro}
                  options={profesionalOptions}
                  isClearable
                  isDisabled={loadingNoteLinks}
                  placeholder="Todos"
                />
              </Col>
              <Col xs={12} md={3}>
                <Form.Label className="mb-1">Paciente</Form.Label>
                <Select
                  className="eethsa-select"
                  classNamePrefix="eethsa-select"
                  value={pacienteFiltro}
                  onChange={setPacienteFiltro}
                  options={pacienteOptions}
                  isClearable
                  isDisabled={loadingNoteLinks}
                  placeholder="Todos"
                />
              </Col>
              <Col xs={12} md={2} className="d-flex align-items-end">
                <Button variant="outline-danger" className="w-100" onClick={limpiarFiltros}>
                  Limpiar
                </Button>
              </Col>
            </Row>
          </Form>

          <div className="d-flex align-items-center justify-content-between mb-2">
            <div className="small text-muted">
              Mostrando <strong>{filteredTop30.length}</strong> de las últimas <strong>30</strong> notas (tras filtros).
            </div>
            <div>
              <Badge bg="warning" text="dark" className="me-2">Pendientes: {totalPend}</Badge>
              <Badge bg="success">Finalizadas: {totalFin}</Badge>
            </div>
          </div>

          {loadingNotes ? (
            <div className="d-flex justify-content-center py-4">
              <Spinner animation="border" />
            </div>
          ) : filteredTop30.length === 0 ? (
            <div className="text-center text-muted py-3">No hay notas que coincidan con los filtros.</div>
          ) : (
            <ListGroup>
              {filteredTop30.map((n) => {
                const esPendiente = (n.estado || "").toUpperCase() === "PENDIENTE";
                return (
                  <ListGroup.Item key={n.id} className="d-flex justify-content-between align-items-start">
                    <div className="ms-2 me-auto">
                      <div className="fw-bold d-flex align-items-center">
                        Nota #{n.id}
                        <Badge
                          bg={esPendiente ? "warning" : "success"}
                          text={esPendiente ? "dark" : undefined}
                          className="ms-2"
                        >
                          {esPendiente ? "PENDIENTE" : "FINALIZADO"}
                        </Badge>
                      </div>
                      <div className="mt-1">{n.descripcion || "(sin descripción)"}</div>
                      {(n.cuenta || n.paciente || n.idusuario || n.idpaciente) && (
                        <div className="text-muted small mt-1">
                          {n.cuenta || n.idusuario ? `Profesional: ${n.cuenta || n.idusuario}` : ""}
                          {(n.cuenta || n.idusuario) && (n.paciente || n.idpaciente) ? " • " : ""}
                          {n.paciente || n.idpaciente ? `Paciente: ${n.paciente || n.idpaciente}` : ""}
                        </div>
                      )}
                      <div className="text-muted small mt-1">
                        {n.usuariocreacion ? `Por ${n.usuariocreacion}` : ""} {n.fechacreacion ? `• ${formatDate(n.fechacreacion)}` : ""}
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      {esPendiente && (
                        <Button
                          size="sm"
                          variant="outline-success"
                          disabled={updatingNoteId === n.id}
                          onClick={() => handleResolveNote(n)}
                        >
                          {updatingNoteId === n.id ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            <>
                              <i className="fas fa-check me-2"></i> Finalizar
                            </>
                          )}
                        </Button>
                      )}
                    </div>
                  </ListGroup.Item>
                );
              })}
            </ListGroup>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={closeNotesModal}>
            Cerrar
          </Button>
          <Button variant="primary" onClick={reloadNotes}>
            Recargar
          </Button>
          {/* === Excel === */}
          <Button
            variant="success"
            onClick={exportFilteredToExcel}
            disabled={loadingNotes || filteredTop30.length === 0}
            title="Exporta a Excel lo que estás viendo (máx. 30)"
          >
            <i className="fas fa-file-excel me-2"></i>
            Exportar Excel
          </Button>
        </Modal.Footer>
      </Modal>

      {/* MODAL: Agregar Nota */}
      <Modal show={showAddNoteModal} onHide={closeAddNoteModal} centered>
        <Form onSubmit={handleSaveNote}>
          <Modal.Header closeButton>
            <Modal.Title>Agregar Nota</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Descripción</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={newNote}
                onChange={(e) => setNewNote(e.target.value)}
                placeholder="Escribe la nota..."
                required
              />
            </Form.Group>
            <Row className="g-2">
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Profesional (opcional)</Form.Label>
                  <Select
                    className="eethsa-select"
                    classNamePrefix="eethsa-select"
                    value={profesionalOptions.find((option) => option.value === String(noteCuenta)) || null}
                    onChange={(option) => setNoteCuenta(option?.value || "")}
                    options={profesionalOptions}
                    isClearable
                    isDisabled={loadingNoteLinks}
                    placeholder="Sin vincular profesional"
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Paciente (opcional)</Form.Label>
                  <Select
                    className="eethsa-select"
                    classNamePrefix="eethsa-select"
                    value={pacienteOptions.find((option) => option.value === String(notePaciente)) || null}
                    onChange={(option) => setNotePaciente(option?.value || "")}
                    options={pacienteOptions}
                    isClearable
                    isDisabled={loadingNoteLinks}
                    placeholder="Sin vincular paciente"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={closeAddNoteModal}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit" disabled={savingNote}>
              {savingNote ? <Spinner animation="border" size="sm" /> : "Guardar"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* MODAL: Cambiar contraseña */}
      <Modal show={showPasswordModal} onHide={handleClosePasswordModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Cambiar Contraseña</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handlePasswordSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Contraseña Actual</Form.Label>
              <Form.Control
                type="password"
                name="currentPassword"
                value={passwordData.currentPassword}
                onChange={handleInputChange}
                placeholder="Ingresa tu contraseña actual"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Nueva Contraseña</Form.Label>
              <Form.Control
                type="password"
                name="newPassword"
                value={passwordData.newPassword}
                onChange={handleInputChange}
                placeholder="Ingresa tu nueva contraseña"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Confirmar Nueva Contraseña</Form.Label>
              <Form.Control
                type="password"
                name="confirmPassword"
                value={passwordData.confirmPassword}
                onChange={handleInputChange}
                placeholder="Confirma tu nueva contraseña"
                required
              />
            </Form.Group>
            <div className="d-flex justify-content-end">
              <Button variant="danger" onClick={handleClosePasswordModal} className="me-2">
                Cancelar
              </Button>
              <Button variant="primary" type="submit">
                Guardar
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Header;
